// Read frozen training content without consulting or rewriting the current catalog.
export function trainingDisplayItem(item, lang = "de") {
  if (item?.training_snapshot == null) return item;
  const snapshot = item.training_snapshot;
  const text = (field, fallback) => {
    const translated = lang === "en" && snapshot?.[`${field}_en`];
    return typeof translated === "string" && translated ? translated
      : typeof snapshot?.[field] === "string" ? snapshot[field] : fallback;
  };
  return { ...item,
    title: text("title", item.title), player_visible_description: text("description", item.player_visible_description),
    training_unit_type: snapshot?.training_unit_type,
    training_template: snapshot?.training_template,
    training_structure: snapshot?.training_structure,
    running_variant: snapshot?.running_variant, running_details: snapshot?.running_details,
  };
}

export function hasTrainingStructure(item) {
  const saved = trainingDisplayItem(item);
  return Boolean(saved?.training_template || saved?.training_structure
    || (item?.training_snapshot != null && !saved?.running_variant));
}

// Release80's forms cannot round-trip frozen catalog references or V2 metadata.
export function legacyTrainingReadOnly(item) {
  return Boolean(item && (item.training_snapshot != null || item.library_template_id != null
    || item.library_template_version != null || item.scope === "global"
    || (item.training_structure != null && item.training_structure.version !== 1)));
}
